<template>
    <div class="row">        
        <input-text class="col-2" label="Nº etapa" disabled v-model="etapaNumero"/>
        <input-text class="col-10 col-md-4" @blur="salvarEtapa" :readonly="ehReadonly(form.previsto)" label="Titulo da etapa" v-model="form.etapa.tituloDaEtapa" ref="tituloEtapa" required/>
        <input-select class="col-12 col-md-3" @input="salvarEtapa" :disabled="!controlesLiberados" :has-error-custom="erroEtapa" :options="mesesDepesas" v-model="form.etapa.mesInicialRealizado" ref="mesInicial" required>
            <template #label>
                <div>
                    <span>Mês inicial</span>
                    <b-badge v-if="verBadge(form.previsto)" class="ml-2">Previsão: {{retornarMes(form.etapa.mesInicial)}}</b-badge>
                </div>
            </template>
        </input-select>
        <input-select class="col-12 col-md-3" @input="salvarEtapa" :disabled="!controlesLiberados" :options="mesesDepesas" v-model="form.etapa.mesFinalRealizado" ref="mesFinal" required>
            <template #label>
                <div>
                    <span>Mês final</span>
                    <b-badge v-if="verBadge(form.previsto)" class="ml-2">Previsão: {{retornarMes(form.etapa.mesFinal)}}</b-badge>
                </div>
            </template>
        </input-select>
        
        <template v-for="subetapa in form.subetapas">
            <div class="col-12" :key="subetapa.id">
                <div class="row">
                    <input-text class="col-2" label="Nº subetapa" readonly v-model="subetapa.numero">
                        <template #prepend>
                            <div class="d-flex">
                                <b-button variant="flat-danger" v-if="botaoExcluirSubetapa(subetapa)" class="mr-2" @click="removerSubetapa(subetapa)"><i class="fas fa-trash"></i></b-button>
                            </div>
                        </template>
                    </input-text>
                    <input-text class="col-11 col-md-4" @blur="salvarSubetapa(subetapa)"  :readonly="ehReadonly(subetapa.prevista)" label="Titulo da subetapa" v-model="subetapa.tituloDaEtapa"/>
                    <input-select class="col-12 col-md-3" :has-error-custom="erroSubetapa" :disabled="!controlesLiberados" @input="salvarSubetapa(subetapa)" label="Mês inicial" :options="mesesDepesas" v-model="subetapa.mesInicialRealizado" ref="mesInicial" required>
                        <template #label>
                            <div>
                                <span>Mês inicial</span>
                                <b-badge v-if="verBadge(subetapa.prevista)" class="ml-2">Previsão: {{retornarMes(subetapa.mesInicial)}}</b-badge>
                            </div>
                        </template>
                    </input-select>
                    <input-select class="col-12 col-md-3" @input="salvarSubetapa(subetapa)" :disabled="!controlesLiberados" label="Mês final" :options="mesesDepesas" v-model="subetapa.mesFinalRealizado" ref="mesFinal" required>
                    <template #label>
                            <div>
                                <span>Mês final</span>
                                <b-badge v-if="verBadge(subetapa.prevista)" class="ml-2">Previsão: {{retornarMes(subetapa.mesFinal)}}</b-badge>
                            </div>
                        </template>
                    </input-select>
                </div>
            </div>
        </template>

        <div class="col-12 mb-4">
            <b-button variant="info" v-if="botaoAdicionarSubetapa" size="sm" @click="adicionarSubetapa()" >
                <b-icon icon="plus-circle-fill" class="mr-2" />
                Adicionar subetapa
            </b-button>
        </div>

        <input-textarea class="col-12" @blur="salvarDetalhamento" label="Detalhamento" v-if="form.previsto" :readonly="ehReadonly(form.previsto)" v-model="form.detalhamento"/>
        <input-textarea class="col-12" @blur="salvarDetalhamento" label="Detalhamento realizado" v-if="projetoIniciado" v-model="form.detalhamentoRealizado"/>
    </div>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect";
import InputTextarea from "@/components/inputs/InputTextarea";
import InputText from "@/components/inputs/InputText";

import {FormMixin} from "@/common/mixins/FormMixin";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";
import ProjetoGestaoService from "@/common/services/projeto_gestao/projeto_gestao.service";

import helpers from "@/common/utils/helpers";
import cloneDeep from "lodash/cloneDeep";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

export default {
    name: "ModalCronograma",
    mixins: [FormMixin, AlertasMixin],
    props: {
        duracao: {
            required: true
        },
        dataInicio: {
            required: true
        },
        form:{
            type: Object,
            required: true
        },
        numeroEtapa: {
            required: true
        },
        projetoIniciado: {
            required: true
        },
    },
    components: {
        InputSelect,
        InputTextarea,
        InputText,
    }, 
    data : () =>({
        erroEtapa : false,
        erroSubetapa : false,
    }),
    methods:{
        retornarMes : function(mes){
            return this.mesesDepesas.find(el => el.value == mes).text;
        },
        salvarDetalhamento : function(){
            if(!this.form.id)
                return;

            let form = cloneDeep(this.form);

                
            form.detalhamento = form.detalhamentoRealizado;
            this.$store.dispatch(START_LOADING);
            ProjetoGestaoService.salvarDetalhamento(form, this.projetoIniciado).then(() => {
                this.toast("Detalhamento atualizado com sucesso", {variant : 'success'});
                this.$emit("update");
            }).catch(() => {
                this.toast("Erro ao atualizar detalhamento", {variant : 'danger'});
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });

        },

        salvarEtapa : function(){
            if(!this.form.id)
                return;

            if(this.form.etapa.mesInicialRealizado == "" || this.form.etapa.mesFinalRealizado == ""){
                return;
            }

            if(this.form.etapa.tituloDaEtapa == ""){
                this.alertaAviso("Preencha o título da etapa");
                this.$refs.tituloEtapa.valid();
                return;
            }

            if(this.form.etapa.mesInicialRealizado > this.form.etapa.mesFinalRealizado){
                this.alertaAviso("O mês inicial não pode ser maior que o mês final");
                this.erroEtapa = "O mês inicial não pode ser maior que o mês final";
                return;
            }

            this.erroEtapa = false;

            let form = cloneDeep(this.form);

            if(!this.projetoIniciado){
                form.etapa.mesInicial = form.etapa.mesInicialRealizado;
                form.etapa.mesFinal = form.etapa.mesFinalRealizado;

                form.etapa.mesInicialRealizado = 0;
                form.etapa.mesFinalRealizado = 0;

            }

            this.$store.dispatch(START_LOADING);
            ProjetoGestaoService.salvarEtapa(form).then(() => {
                this.toast("Etapa salva com sucesso", {variant : 'success'});
                this.$emit("update");
            }).catch(() => {
                this.toast("Erro ao salvar etapa", {variant : 'danger'});
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });

        },

        salvarSubetapa : function(subetapa){

            if(!this.form.id)
                return;

            if(!subetapa.mesInicialRealizado || !subetapa.mesFinalRealizado ){
                return;
            }

            if(subetapa.tituloDaEtapa == ""){
                this.alertaAviso("Preencha o título da etapa");
                return;
            }

            if(subetapa.mesInicialRealizado > subetapa.mesFinalRealizado){
                this.alertaAviso("O mês inicial não pode ser maior que o mês final");
                this.erroSubetapa = "O mês inicial não pode ser maior que o mês final";
                return;
            }

            this.erroSubetapa = false;

            let form = cloneDeep(subetapa);

            if(!this.projetoIniciado){
                form.mesInicial = form.etapa.mesInicialRealizado;
                form.mesFinal = form.etapa.mesFinalRealizado;

                form.mesInicialRealizado = 0;
                form.mesFinalRealizado = 0;
            }

            this.$store.dispatch(START_LOADING);
            ProjetoGestaoService.salvarSubetapa(form).then(res => {
                if(res){
                    delete subetapa.cronogramaEtapaId;
                    subetapa.id = res;
                }

                this.toast("Subetapa salva com sucesso", {variant : 'success'});
                this.$emit("update");
            }).catch(() => {
                this.toast("Erro ao salvar subetapa", {variant : 'danger'});
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },

        salvarRelatorio : function(relatorio){

            if(!this.form.id)
                return;

            if(!relatorio.dataEmissao){
                return;
            }

            if(relatorio.titulo == ""){
                this.alertaAviso("Preencha o título do relatório");
                return;
            }

            this.$store.dispatch(START_LOADING);
            ProjetoGestaoService.salvarRelatorio(relatorio).then(res => {
                if(res){
                    delete relatorio.cronogramaEtapaId;
                    relatorio.id = res;
                    this.$forceUpdate();
                }
                this.toast("Relatório salvo com sucesso", {variant : 'success'});
                this.$emit("update");
            }).catch(() => {
                this.toast("Erro ao salvar relatório", {variant : 'danger'});
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },

        adicionarSubetapa: function(){
            let numero = (
                this.form.subetapas.length == 0 ? 1 : 
                parseInt(this.form.subetapas[this.form.subetapas.length - 1].numero.substring(
                    this.form.subetapas[this.form.subetapas.length - 1].numero.indexOf('.') + 1
                )) + 1
            );
            
            this.form.subetapas.push({
                cronogramaEtapaId : this.form.id,
                numero: `${this.numeroEtapa}.${numero}`,
                tituloDaEtapa : null,
                mesInicial: null,
                mesFinal: null,
                mesInicialRealizado: null,
                mesFinalRealizado: null,
                prevista: !this.projetoIniciado
            });
        },

        removerSubetapa: function(subetapa){
            if(subetapa.id){
                this.confirmar('Alerta', 'Deseja realmente remover esta subetapa?').then(
                    v => {
                        if(v){
                            ProjetoGestaoService.removerSubetapa(subetapa.id).then(() => {
                                this.form.subetapas.splice(this.form.subetapas.indexOf(subetapa), 1);
                                this.toast("Subetapa removido com sucesso", {variant : 'success'});
                                this.$emit("update");
                            }).catch(() => {
                                this.toast("Erro ao remover subetapa", {variant : 'danger'});
                            }); 
                        }
                    }
                )
            }else
                this.form.subetapas.splice(this.form.subetapas.indexOf(subetapa), 1);
        },

        verBadge: function(previsto){
            return previsto && this.projetoIniciado
        },
        ehReadonly : function(previsto){
            return (previsto && this.projetoIniciado) || !this.controlesLiberados
        },
        botaoExcluirSubetapa: function(subetapa){
            return (this.projetoIniciado ? !subetapa.prevista : true) && this.controlesLiberados
        },
    },
    computed:{
        botaoAdicionarSubetapa : function(){
            return (this.projetoIniciado ? !this.form.previsto : true) && this.controlesLiberados;
        },
        mesesDepesas : function(){
            let meses = [];
            
            let ano = this.dataInicio;
            let mes = 4;
            if(this.projetoIniciado){
                ano = helpers.formatarData(this.dataInicio, 'YYYY');
                mes = helpers.formatarData(this.dataInicio, 'MM');
            }
            
            let totalMeses = this.projetoIniciado ? this.duracao + 1 : this.duracao;
            for (let index = 0; index < totalMeses; index++) {
                meses.push({
                    value: index+1,
                    text: this.projetoIniciado ? `${helpers.retornarNomeMes(mes)}/${ano}` : `Mês ${index +1}`
                });
                
                mes++;
                if(mes > 12){
                    mes = 1;
                    ano++;
                }
            }
            return meses;
        },
        etapaNumero: {
            get : function(){    
                return (this.form.etapa.numero ? this.form.etapa.numero : this.numeroEtapa);
            },
        },
        controlesLiberados :function(){
            return this.$route.name == 'projeto-gestao-proponente-detalhamento'
        },
    },
    watch:{
        numeroEtapa:{
            handler: function(){
                if(!this.form.id)
                    this.form.etapa.numero = this.numeroEtapa;
            },
            immediate: true
        }
        
    }
}
</script>
<style lang="">
    
</style>